import styled from 'styled-components'
import NavigationButtonsComponent from '../../molecules/NavigationButtons/NavigationButtons'
import colors from '../../theme/colors'

export const Divider = styled.hr`
  margin: 16px 0;
  border: 1px solid ${colors.Primary.Grey};
`

export const NavigationButtons = styled(NavigationButtonsComponent)`
  margin-top: 48px;
  padding: 0;
`
